import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { capitalizeFirstLetter } from '@utils/StringUtils';
import {
  addAllProductGroupFilter,
  addCountryLoadedTagInPlace,
  addPgLoadedTagInPlace,
  getGeneralCollectionInsightTags,
  getIsUsingCollectionLiveData,
  getPeriodLabel,
} from '@utils/collectionUtils/CollectionUtils';
import { TrendStackBarChartInsight } from './Model';
import { getBaseTimePeriodForMATAndYTD, getPeriodicityForMATAndYTD } from '@utils/PeriodUtils';
import { getCountryCodes } from '@utils/CountryUtils';
import { getRequireAllPgLoadedInCollections } from '@components/collections/CollectionsFlagsByInsightType';
import { CollectionInsightType } from '@components/collections/Model';
import { getStackChartSalesType } from '@models/ExploreTrendsStackChart';
export const getTrendStackBarChartInsightInfoTags = async (insight: TrendStackBarChartInsight) => {
  const {
    apiParams: { clientId, countries, productGroup, productType, period, comparisonPeriod, appliedFilters, periodType },
    selectedGrowthType,
    selectedFeature,
    retailerClientName,
    collectionDataType,
  } = insight;

  const baseTimePeriod = getBaseTimePeriodForMATAndYTD(period, periodType);
  const { periodicity } = getPeriodicityForMATAndYTD(baseTimePeriod, periodType);
  const requireAllPgLoadedInCollections = getRequireAllPgLoadedInCollections(CollectionInsightType.TrendStackBarChart);

  const periodLabel = await getPeriodLabel({
    clientId,
    periodicity,
    baseTimePeriod,
    comparisonPeriod,
    countryIds: getCountryCodes(countries),
    productType,
    collectionDataType: getIsUsingCollectionLiveData(period, collectionDataType) ? 'live' : collectionDataType,
    productGroups: productGroup,
    requireAllPgLoadedInCollections,
  });

  const generalCollectionInsightTags = getGeneralCollectionInsightTags({
    periodType: periodicity,
    comparisonPeriod,
    selectedGrowthType: selectedGrowthType,
    appliedFilters: addAllProductGroupFilter(appliedFilters),
    retailerClientName,
    period: periodLabel,
  });

  const baseApiParams = {
    clientId,
    countries: countries,
    productType,
    period: period,
    comparisonPeriod: RelativePeriod.PreviousYearCurrentPeriod,
    productGroup: productGroup ?? [],
    periodType: periodicity,
    appliedFilters: [],
  };
  const isMultiCountrySelected = countries?.length > 1;
  if (isMultiCountrySelected) {
    await addCountryLoadedTagInPlace(generalCollectionInsightTags, baseApiParams, collectionDataType);
  } else {
    await addPgLoadedTagInPlace(
      generalCollectionInsightTags,
      baseApiParams,
      collectionDataType,
      requireAllPgLoadedInCollections,
    );
  }
 
  return [
    ...generalCollectionInsightTags,
    {
      key: 'Show',
      value: capitalizeFirstLetter(selectedFeature.value),
    },
    {
      key: 'SaleType',
      value: capitalizeFirstLetter(getStackChartSalesType(insight.selectedSaleType)),
    },
    {
      key: 'SaleFormat',
      value: capitalizeFirstLetter(insight.selectedAbsoluteType),
    },
  ];
};
